import ASTBlock from "../ASTBlock";
import Blockly from 'blockly';

export default class AlvikButtonPress extends ASTBlock {
    constructor(color) {
        super(color, "alvik_button_press")
        this.predefinedInputs = {}
        this.TOP_LEVEL = undefined
    }

    addToBlockly() {
        var json = {
            "tooltip": "",
            "helpUrl": "",
            "message0": "%1 Knopf wurde gedrückt %2",
            "args0": [{
                    "type": "field_dropdown",
                    "name": "button",
                    "options": [
                        [
                            "OK",
                            "ok"
                        ],
                        [
                            "Abbruch",
                            "cancel"
                        ],
                        [
                            "mittlerer",
                            "center"
                        ],
                        [
                            "oberer",
                            "up"
                        ],
                        [
                            "unterer",
                            "down"
                        ],
                        [
                            "linker",
                            "left"
                        ],
                        [
                            "rechter",
                            "right"
                        ]
                    ]
                },
                {
                    "type": "input_dummy",
                    "name": "NAME"
                }
            ],
            "output": "Boolean"
        }

        let that = this
        Blockly.Blocks[this.name] = {
            init: function() {
                this.jsonInit(json);
                this.setColour(that.color)
            }

        }
    }
}